export enum BLUETOOTH_KEYS {
  FEATURES_KEY = 'bluetoothFeaturesKey',
  INSTRUCTIONS_KEY = 'bluetoothInstructionsKey',
  CALLING_TEXTING_INSTRUCTION_KEY = 'bluetoothCallingTextingInstructionKey',
  YEARS_KEY = 'bluetoothVehicleYearsKey',
  MODELS_KEY = 'bluetoothVehicleModelsKey',
  TOTAL_CONNECT_FEATURES_KEY = 'bluetoothFeatures',
  UNAUTHENTICATED_DEVICE_KEY = 'unauthenticatedBluetoothDeviceKey',
  RETRIEVE_INSTRUCTION_SET = 'retrieveBluetoothInstructionSet'
}

export enum RADIO_OPTIONS_KEYS {
  BUICK = 'IntelliLink',
  CADILLAC = 'CUE',
  CHEVROLET = 'MyLink',
  CHEVY = 'MyLink',
  GMC = 'IntelliLink'
}

export enum OC_LEAD_META_KEYS {
  EMAIL = 'email',
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  OCLEAD_GUID = 'ocLeadId',
  ONSTAR_ACCOUNT = 'onstarAccount',
  SESSION_VIN = 'leadvin',
  VIN = 'vin'
}

export enum MAKE_KEYS {
  CHEVY = 'chevy',
  GEO = 'geo',
  GM = 'gm',
  GMC = 'gmc',
  HUMMER = 'hummer',
  OLDSMOBILE = 'oldsmobile',
  PONTIAC = 'pontiac',
  SAAB = 'saab',
  SATURN = 'saturn'
}

export enum ONSTAR_KEYS {
  ENTITLEMENTS = 'onstarEntitlements'
}

export enum CHROME_MMY_VALUES_KEY {
  CHROME_MMY_VALUES = 'chromeMmyValues'
}

export const MISC_KEYS = {
  OPTIONS_TAG_PREFIXES: ['GMNA/option/', 'GMNA/option/radios/'],
  PREFERENCES_ENABLED: true,
  SESSION_TIMEOUT_THRESHOLD: (29) * (60000)  // (minutes)*(milliseconds in a minute) Lowered by 1 minute to keep up with backend session expiration
} as const;
